import React, { useState } from 'react'
import { ReadyCountChangeItem } from './ReadyCountChangeItem'

export const SubuserItem = (
  {
    data,
    maxValue,
    setInitData,
    modal
  }
) => {
  const [isOpen, setIsOpen] = useState(false)
  const {user, changesList, totalReadyCount} = data

  const onOpenDetails = () => {
    setIsOpen(!isOpen)
  }

  return (
    <div className={`text-Regular(16_18) pt-[0.6rem] flex flex-col items-start [&:not(:first-child)]:border-t [&:not(:first-child)]:border-[#c9c9c9]`}>
      <div className={`flex items-center gap-[12px] hover:cursor-pointer`}  onClick={onOpenDetails}>
        <div>
          {user.username}: <span className={`font-bold`}>{totalReadyCount}</span>
        </div>
        <div className={`flex items-center`}>
          <i className={`${isOpen ? 'rotate-180' : ''} text-Accent/Blue icon-arrow text-Regular(12_14) duration-300 ease-in-out m-auto  inline-flex items-center justify-center`}></i>
        </div>
      </div>
      <div className={`inline-flex flex-col transition-[max_height] mt-[4px] ${isOpen ? 'h-auto max-h-[1000px] duration-300 ease-in-out' : 'max-h-[0] pointer-events-none opacity-0'}`}>
        {changesList.map((item) => {
          return <ReadyCountChangeItem data={item} maxValue={maxValue} setInitData={setInitData} modal={modal}/>
        })}
      </div>
    </div>
  )
}